function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import LocaleKeys from '../../../../../../locales/keys';
import { CHARGE_TIMING } from '../../../../../../reducers/constants/wizard.constants';
import { getRetrieveOrderQuoteCountdown } from '../../../../../../reducers/helpers/async.helper';
import { determineClassForComponent } from '../cart.helper';
var FullCartController = /*#__PURE__*/function () {
  function FullCartController() {
    _classCallCheck(this, FullCartController);
    Object.assign(this, {
      assignedClass: null,
      CHARGE_TIMING: CHARGE_TIMING,
      getRetrieveOrderQuoteCountdown: getRetrieveOrderQuoteCountdown,
      hideItem: [],
      isExpanded: {
        offeringOrderQuotes: [],
        shippingQuotes: false,
        taxQuotes: false,
        renewalSchedulesQuotes: []
      },
      isHeaderExpanded: true,
      LocaleKeys: LocaleKeys,
      onOffcycleOptionSelect: this.onOffcycleOptionSelect.bind(this),
      updateExpandProperty: this.updateExpandProperty.bind(this),
      ORDER_TOTALS: i18n.translate(LocaleKeys.OFFCYCLE_CART.ORDER_TOTALS),
      RENEWAL_SCHEDULE: i18n.translate(LocaleKeys.OFFCYCLE_CART.RENEWAL_SCHEDULE)
    });
  }
  return _createClass(FullCartController, [{
    key: "$onInit",
    value: function $onInit() {
      if (this.hasOffcycleOrders) {
        this.offcyleDropdownOptions = [{
          text: this.ORDER_TOTALS,
          selected: true
        }, {
          text: this.RENEWAL_SCHEDULE,
          selected: false
        }];
      }
      this.assignedClass = determineClassForComponent(this.showHideFullCartColumns);
    }
  }, {
    key: "onOffcycleOptionSelect",
    value: function onOffcycleOptionSelect(item) {
      this.offcyleDropdownOptions.forEach(function (option) {
        option.selected = option.text === item.text;
      });
      this.selectedOffcycleDropdown = item.text;
      if (item.text === this.RENEWAL_SCHEDULE) {
        this.assignedClass = determineClassForComponent();
        this.isExpanded.renewalSchedulesQuotes[0] = true;
      } else {
        this.assignedClass = determineClassForComponent(this.showHideFullCartColumns);
        this.collapseAll();
      }
    }
  }, {
    key: "expandAll",
    value: function expandAll() {
      for (var i in this.isExpanded) {
        if (Array.isArray(this.isExpanded[i])) {
          this.updateExpandProperty(i, true);
        } else {
          this.isExpanded[i] = true;
        }
      }
    }
  }, {
    key: "collapseAll",
    value: function collapseAll() {
      for (var i in this.isExpanded) {
        if (Array.isArray(this.isExpanded[i])) {
          this.updateExpandProperty(i, false);
        } else {
          this.isExpanded[i] = false;
        }
      }
    }
  }, {
    key: "updateExpandProperty",
    value: function updateExpandProperty(index, value) {
      for (var item = 0; item <= (index === 'renewalSchedulesQuotes' ? this.renewalSchedules.length : this.offeringOrderQuotes.length); item++) {
        this.isExpanded[index][item] = value;
        if (this.offeringOrderQuotes[item] && this.offeringOrderQuotes[item].isPlaceHolderForExistingItems) {
          this.expandExistingHeaderItems(item, !value);
        }
      }
    }
  }, {
    key: "onExpandToggle",
    value: function onExpandToggle(quoteItem, index) {
      if (quoteItem === 'offeringOrderQuotes' || quoteItem === 'renewalSchedulesQuotes') {
        this.isExpanded[quoteItem][index] = !this.isExpanded[quoteItem][index];
      } else {
        this.isExpanded[quoteItem] = !this.isExpanded[quoteItem];
      }
    }
  }, {
    key: "expandExistingHeaderItems",
    value: function expandExistingHeaderItems(index, value) {
      for (var i = 0; i <= this.offeringOrderQuotes.length; i++) {
        if (i > index) {
          this.hideItem[i] = value || !this.hideItem[i];
        }
      }
    }
  }]);
}();
export default {
  bindings: {
    currency: '<',
    displayAsyncQuoteMessage: '<?',
    fees: '<',
    isChange: '<?',
    isEdit: '<?',
    isNewConnect: '<?',
    handleEdit: '&',
    handleRemove: '&',
    renewalSchedules: '<',
    hasOffcycleOrders: '<',
    gotoDecisionsPage: '&?',
    offeringOrderQuotes: '<',
    onClose: '&',
    onRefreshQuote: '&?',
    retrieveOfferingOrderQuoteTimestamp: '<?',
    selectedOfferingInstanceId: '<',
    shipping: '<?',
    showHideFullCartColumns: '<',
    subtotal: '<',
    taxes: '<'
  },
  template: require('./full.cart.html'),
  controller: FullCartController
};